import {
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import Height from "components/height/height";
import { useState } from "react";
import { appConstants } from "utils/appConstants";

const CheckoutForm = ({ ...props }) => {
  const stripe = useStripe();
  const elements = useElements();
  // const elements = stripe.elements();
  // const elements = useElements();

  const [errorMessage, setErrorMessage] = useState(null);

  const cancel = async () => {
    window.location.reload();
  };
  const handleSubmit = async (event) => {
    props.loading(true);
    event.preventDefault();
    let url;
    if (props.type === "CusOrder") {
      url = `${appConstants.frontendURL}addCustOrder/new?orderID=${props.orderID}`;
    } else {
      url = `${appConstants.frontendURL}billing?planID=${props.planID}&OldPlanID=${props.oldPlanID}&PlanName=${props.oldPlanName}&TransactionType=${props.transactionType}`;
    }

    await stripe
      .confirmPayment({
        elements,
        confirmParams: {
          return_url: url,
        },
      })
      .then((val) => {})
      .catch((error) => {
        setErrorMessage(error.message);
        props.loading(false);
        console.log("asdasdas", error.message);
      });

    // if (error) {
    //   console.log("Adfsafdsafawerwerwewe" ,error)
    //   setErrorMessage(error.message);
    // } else {
    //   console.log("sdfsdfsfsffs")

    //   // Your customer will be redirected to your `return_url`. For some payment
    //   // methods like iDEAL, your customer will be redirected to an intermediate
    //   // site first to authorize the payment, then redirected to the `return_url`.
    // }
  };

  // const appearance = {
  //   theme: 'night',
  //   variables: {
  //     fontFamily: 'Sohne, system-ui, sans-serif',
  //     fontWeightNormal: '500',
  //     borderRadius: '8px',
  //     colorBackground: '#0A2540',
  //     colorPrimary: '#EFC078',
  //     accessibleColorOnColorPrimary: '#1A1B25',
  //     colorText: 'white',
  //     colorTextSecondary: 'white',
  //     colorTextPlaceholder: '#727F96',
  //     tabIconColor: 'white',
  //     logoColor: 'dark'
  //   },
  //   rules: {
  //     '.Input, .Block': {
  //       backgroundColor: '#000',
  //       border: '1.5px solid var(--colorPrimary)'
  //     }
  //   }
  // }

  // Pass the appearance object to the Elements instance
  return (
    <>
      <form onSubmit={handleSubmit} style={props.p && { padding: props.p }}>
        <PaymentElement className="paymentMethod" theme="night" />

        <Height val={10} />
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <button
            type="button"
            style={{
              width: "110px",
              height: "40px",
              borderRadius: "10px",
              color: "white",
              border: "0px",
              background: "#fb8c00",
              marginRight: "10px",
            }}
            onClick={cancel}
            disabled={!stripe}
          >
            Cancel
          </button>
          <button
            style={{
              width: "110px",
              height: "40px",
              borderRadius: "10px",
              color: "white",
              border: "0px",
              background: "#4caf50",
            }}
            disabled={!stripe}
          >
            Pay
          </button>
        </div>
        {errorMessage && <div>{errorMessage}</div>}
        {/* Show error message to your customers */}
      </form>
    </>
  );
};

export default CheckoutForm;
